module.exports = __webpack_public_path__ + "static/media/Adventure.433873eb.mp4";